<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.section--login
      +b.withdraw--created
        +b.ma--b_md.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'4xl'"
          :color="'black'"
          :tag="'p'"
        ) Order created:
        +b.control-cabinet.ma--b_md
          +e.element--centered.--border.pa--r_1md {{ formData.link || '-'}}
          +e.copy-action.button--copy.BUTTON(
            v-clipboard:copy="formData.link"
            @click.prevent="copyLinkHandler"
          )
            +b.icon--type_copy.I
        validation-observer(
          ref="observer"
          tag="form"
          class="form"
        )
          +b.ug-row--apearance_spaced.--space_md.--justify_end
            +b.ug-cell.ug-cols--12
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'initial'"
                :fs="'xl'"
                :color="'black'"
                :tag="'p'"
              ) SMS Service
            +b.ug-cell.ug-cols--12
              +b.input.D-CONTROL-INPUT(
                v-model="formData.phone"
                :placeholder="'Phone Number *'"
                :rules="{required: true}"
                :name="'phone'"
                :type="'tel'"
                id="phone"
              )
            +b.ug-cell.ug-cols--12
              +b.cabinet-textarea
                +b.input.D-CONTROL-TEXTAREA(
                  v-model="formData.message"
                  :placeholder="'Comments *'"
                  :rules="{required: true}"
                  :name="'message'"
                  :type="'text'"
                  id="message"
                )
            +b.ug-cell.ug-cols--12.--6-md
              +b.button--height_xl.BUTTON-BEMTO(
                :disabled="isRequest"
                @event="validateBeforeSubmit(formData)"
              )
                +e.load.IMG(
                  src="/static/load.gif"
                  v-if="isRequest"
                )
                +e.text(
                  v-if="!isRequest"
                ) SEND
</template>

<script>
import FormMixin, {defaultValidatorErrorsParser} from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import { postSendSmsAPI } from '@/js/services/cabinet'

export default {
  name: 'CreateOrderCabinet',
  props: [
    'objectItem',
  ],
  mixins: [
    FormMixin,
    ToggleModalMixin,
  ],
  created() {
    this.getSessionStorageHandler()
  },
  data() {
    return {
      /**
       * Components state.
       */
      formData: {
        ...this.objectItem,
      },
      isRequest: false,
    }
  },
  methods: {
    getSessionStorageHandler() {
      if (this.objectItem) {
        sessionStorage.setItem('formdata_co', JSON.stringify(this.formData))
      } else {
        const obj = sessionStorage.getItem('formdata_co')
        if (obj) {
          this.formData = JSON.parse(obj)
        }
      }
    },
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      return postSendSmsAPI.execute(
        {}, data
      )
        .then(response => {
          const OPTIONS = {
            title: response.data.item.message,
            url: '/cabinet/order-history/',
          }
          /**
           * Clear component state.
           */
          this.$refs.observer.reset()
          /**
           * Show success message.
           */
          this.toggleModalMixin(
            'RedirectModal', OPTIONS
          )
        })
    },
    copyLinkHandler() {
      this.toggleToster(
        'Link copied'
      )
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/CreateOrderCabinet.vue